module.exports = __webpack_public_path__ + "img/muchbetter.0dc3bebd.svg";